module.exports = __webpack_public_path__ + "static/media/stuff-category.0e4bb87d.png";